<template>
    <div id="app">
        <router-view />
        <win-celebration ref="winCelebration" />
    </div>
</template>

<script>
import WinCelebration from '@/components/common/WinCelebration.vue';
import socket from '@/utils/socket';
import { parseBetSettleMessage } from '@/utils/betSettle';
import { parseLottoUpdateMessage } from '@/utils/lottoUpdate';

export default {
    components: {
        WinCelebration,
    },
    created() {
        this.handleSocketMessage = this.handleSocketMessage.bind(this);
        socket.on('message', this.handleSocketMessage);
    },
    beforeDestroy() {
        socket.off('message', this.handleSocketMessage);
    },
    methods: {
        handleSocketMessage(message) {
            const lottoResult = parseLottoUpdateMessage(message);
            if (lottoResult) {
                this.$root.$emit('lotto-update', lottoResult);
                return;
            }

            const result = parseBetSettleMessage(message);
            if (!result) {
                return;
            }

            if (result.hasWin && this.$refs.winCelebration) {
                this.$refs.winCelebration.play({
                    issue: result.issue,
                    profitText: result.profitText,
                });
            }

            this.$root.$emit('bet-settle', result);
        },
    },
};
</script>

<style>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html, body {
    height: 100%;
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
    overscroll-behavior: none;
    touch-action: pan-y;
    background-color: #f5f5f5;
}

#app {
    width: 100%;
    max-width: 100%;
    min-height: 100vh;
    margin: 0 auto;
    overflow-x: hidden;
    background-color: #ffffff;
    transition: all 0.2s;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
}

@media (min-width: 641px) {
    #app {
        width: 640px;
        box-shadow: 0 0 30px rgba(0, 0, 0, 0.15);
        min-height: 100vh;
    }
}
</style>
